interface Props {
  data: number[]
  className?: string
}

// SVG a mano, sin librería de charts — el proyecto evita dependencias nuevas
// para un adorno visual (mandamiento contra abstracciones especulativas).
export function Sparkline({ data, className }: Props) {
  if (data.length < 2) return null

  const width = 100
  const height = 28
  const max = Math.max(...data)
  const min = Math.min(...data)
  const range = max - min || 1
  const step = width / (data.length - 1)

  const points = data.map((value, index) => {
    const x = index * step
    const y = height - ((value - min) / range) * height
    return `${x},${y}`
  })

  const [lastX, lastY] = points[points.length - 1].split(',').map(Number)

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className={className} preserveAspectRatio="none" aria-hidden="true">
      <polyline
        points={points.join(' ')}
        fill="none"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-current"
      />
      <circle cx={lastX} cy={lastY} r={2.5} className="fill-current" />
    </svg>
  )
}
